import {
  ADFORM_PREBID_BIDDER,
  RTBHOUSE_PREBID_BIDDER,
  YANDEX_PREBID_BIDDER,
  INDEX_EXCHANGE_BIDDER,
  PUBMATIC_PREBID_BIDDER,
  THEADX_PREBID_BIDDER,
  ADMATIC_PREBID_BIDDER,
  ESKIMI_PREBID_BIDDER,
  ONEFIFTYTWOMEDIA_PREBID_BIDDER,
  TEADS_PREBID_BIDDER,
} from '../bidders';

export const articleAdUnits = {
  desktop: {
    icerikArasiTopLeft: {
      name: 'Onedio.com_Desktop_İçerikArası_Top',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Top',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiTopRight: {
      name: 'Onedio.com_Desktop_İçerikArası_TopRight',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Top',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiBottomLeft: {
      name: 'Onedio.com_Desktop_İçerikArası_Bottom',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Bottom',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiBottomRight: {
      name: 'Onedio.com_Desktop_İçerikArası_BottomRight',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Bottom',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle1Left: {
      name: 'Onedio.com_Desktop_İçerikArası_Middle1',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Middle1',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle1Right: {
      name: 'Onedio.com_Desktop_İçerikArası_Middle1Right',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Middle1',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle2Left: {
      name: 'Onedio.com_Desktop_İçerikArası_Middle2',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Middle2',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle2Right: {
      name: 'Onedio.com_Desktop_İçerikArası_Middle2Right',
      sizes: [[300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      isProject: true,
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Incontent_Middle2',
          sizes: [[300, 250], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikYaniSponTop: {
      name: 'Onedio.com_Desktop_Sponsored_İçerikYanı_Top',
      sizes: [[300, 250], 'fluid'],
      isProject: true,
      cls: 'max',
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Sidebar_Top',
          sizes: [[200, 200], [300, 250], [250, 250], 'fluid'],
        },
      },
    },
    icerikYaniTop: {
      name: 'Onedio.com_Desktop_İçerikYanı_Top',
      sizes: [[300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      isProject: true,
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Sidebar_Top',
          sizes: [[200, 200], [300, 250], [250, 250], 'fluid'],
        },
      },
    },
    icerikYaniMid3: {
      name: 'Onedio.com_Desktop_İçerikYanı_Middle3',
      sizes: [[300, 600], [300, 250], 'fluid'],
      isProject: true,
      refreshTimer: 30,
      visibleRefresh: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666438),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508958),
          THEADX_PREBID_BIDDER(747),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Sidebar_Bottom',
          sizes: [[336, 280], [200, 200], 'fluid', [300, 600], [250, 250], [300, 250]],
        },
      },
    },
    bottomBranding: {
      name: 'Onedio.com_Desktop_SponsoredCategory_BottomBranding',
      sizes: ['fluid'],
      disableShift: true,
    },
    interstitialPaid: {
      name: 'Onedio.com_Desktop_Interstitial_Paid',
      divId: 'article_interstitial_paid',
      hideLoading: true,
      sizes: [[1, 1]],
      isOutOfPage: true,
      queryString: {
        includes: [{ utm_source: 'meta-lp' }, { utm_medium: 'pmax' }],
        excludes: [],
      },
    },
  },
  mobile: {
    icerikArasiTop: {
      name: 'Onedio.com_Mobile_İçerikArası_Top',
      sizes: [[300, 250], [320, 480], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508965),
          THEADX_PREBID_BIDDER(759),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Incontent_Top',
          sizes: [[336, 280], [320, 480], [320, 150], [320, 100], [300, 250], [300, 100], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle1: {
      name: 'Onedio.com_Mobile_İçerikArası_Middle1',
      sizes: [[300, 250], [320, 480], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674483),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508965),
          THEADX_PREBID_BIDDER(759),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Incontent_Middle1',
          sizes: [[336, 280], [320, 480], [320, 150], [320, 100], [300, 250], [300, 100], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiMiddle2: {
      name: 'Onedio.com_Mobile_İçerikArası_Middle2',
      sizes: [[300, 250], [320, 480], [320, 100], [320, 150], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508965),
          THEADX_PREBID_BIDDER(759),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Incontent_Middle2',
          sizes: [[336, 280], [320, 480], [320, 150], [320, 100], [300, 250], [300, 100], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikArasiBottom: {
      name: 'Onedio.com_Mobile_İçerikArası_Bottom',
      sizes: [[300, 250], [320, 480], [320, 100], [320, 150], 'fluid'],
      isProject: true,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674483),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508965),
          THEADX_PREBID_BIDDER(759),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Incontent_Bottom',
          sizes: [[336, 280], [320, 480], [320, 150], [320, 100], [300, 250], [300, 100], [250, 250], [200, 200], 'fluid'],
        },
      },
    },
    icerikSonuDikey1: {
      name: 'Onedio.com_Mobile_Sponsored_İçerikSonu_Dikey1',
      sizes: [[320, 100], [300, 100], 'fluid'],
      disableShift: true,
    },
    icerikSonuDikey2: {
      name: 'Onedio.com_Mobile_Sponsored_İçerikSonu_Dikey2',
      sizes: [[320, 100], [300, 100], 'fluid'],
      disableShift: true,
    },
    icerikSonuDikey3: {
      name: 'Onedio.com_Mobile_Sponsored_İçerikSonu_Dikey3',
      sizes: [[336, 280], 'fluid'],
      disableShift: true,
    },
    bottomBranding: {
      name: 'Onedio.com_Mobile_SponsoredCategory_BottomBranding',
      sizes: ['fluid'],
      disableShift: true,
    },
    StnMasthead: {
      name: 'Onedio.com_Mobile_Masthead_STN',
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1012352),
          RTBHOUSE_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
          ONEFIFTYTWOMEDIA_PREBID_BIDDER,
          TEADS_PREBID_BIDDER,
        ],
      },
      sizes: [
        [320, 150],
        [300, 100],
        [300, 250],
        [320, 100],
      ],
    },
    interstitialPaid: {
      name: 'Onedio.com_Mobile_Interstitial_Paid',
      divId: 'article_interstitial_paid',
      hideLoading: true,
      sizes: [[1, 1]],
      isOutOfPage: true,
      queryString: {
        includes: [{ utm_source: 'meta-lp' }, { utm_medium: 'pmax' }],
        excludes: [{ utm_source: 'meta-cp' }],
      },
    },
  },
};
